import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'
import { ModalShellComponent } from '../modal-shell/modal-shell.component'
import { ChangelogRelease } from '../../../core/whats-new/changelog'

/**
 * WhatsNewDialogComponent — renders the changelog releases passed in.
 *
 * Presentational only: the caller decides *which* releases to show (auto vs.
 * full, role-filtered) and this component just lays them out. Dismissible via
 * backdrop/Escape or the "Got it" button — all routed through `dismissed`.
 */
@Component({
  selector: 'app-whats-new-dialog',
  standalone: true,
  imports: [ModalShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-modal-shell activityName="whats_new"
      title="What's New"
      size="lg"
      [closeOnBackdrop]="true"
      (closed)="dismissed.emit()">

      <div class="whats-new-content">
        @for (release of releases; track release.version) {
          <section class="release">
            <header class="release-header">
              <h3 class="release-version">Version {{ release.version }}</h3>
              <span class="release-date">{{ release.date }}</span>
            </header>
            <ul class="release-entries">
              @for (entry of release.entries; track entry.text) {
                <li>{{ entry.text }}</li>
              }
            </ul>
          </section>
        } @empty {
          <p class="empty">There's nothing new to report right now.</p>
        }
      </div>

      <div actions>
        <button class="btn btn-primary" (click)="dismissed.emit()">Got it</button>
      </div>

    </app-modal-shell>
  `,
  styles: [`
    .whats-new-content { display: flex; flex-direction: column; gap: 20px; padding-bottom: 4px; }
    .release { display: flex; flex-direction: column; gap: 8px; }
    .release-header { display: flex; align-items: baseline; gap: 10px; }
    .release-version { margin: 0; font-size: 0.95rem; font-weight: 600; color: var(--color-text-body); }
    .release-date { font-size: 0.75rem; color: var(--color-text-secondary); }
    .release-entries { margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 4px; }
    .release-entries li { font-size: 0.85rem; color: var(--color-text-secondary); line-height: 1.5; }
    .empty { margin: 0; font-size: 0.85rem; color: var(--color-text-secondary); }
  `]
})
export class WhatsNewDialogComponent {
  @Input() releases: ChangelogRelease[] = []
  @Output() dismissed = new EventEmitter<void>()
}
